const savedVistaActiva = localStorage.getItem('vista-difusion-activa') ?
  JSON.parse(localStorage.getItem('vista-difusion-activa')) : null
const allVistas = {}
if (savedVistaActiva) {
  allVistas[savedVistaActiva.id] = savedVistaActiva
}

export default {
  state: {
    vistaActivaId: savedVistaActiva ? savedVistaActiva.id : null,
    showSideNav: false,
    allVistas: allVistas,
    loadedAllVistas: false,
    publicacionesDisponibles: null,

    //Cosas de productos relacionados a K10 que van a dar F3
    productoToF3: null,
    costoF3: 0,

    patrocinadorK10Data: null,
  },
  mutations: {
    SET_VISTA_ACTIVA_ID(state, id) {
      state.vistaActivaId = id
    },
    SET_SHOW_SIDE_NAV(state, bool) {
      state.showSideNav = bool
    },
    SET_ALL_VISTAS(state, obj) {
      state.allVistas = obj
    },
    SET_VISTA_IN_ALL_VISTAS(state, vista) {
      state.allVistas[vista.id] = vista
    },
    SET_LOADED_ALL_VISTAS(state, bool) {
      state.loadedAllVistas = bool
    },
    SET_PUBK10_DISPONIBLES(state, number) {
      state.publicacionesDisponibles = number
    },

    //Cosas de productos relacionados a K10 que van a dar F3
    SET_PRODUCTO_TO_F3(state, orden) {
      state.productoToF3 = orden
    },
    SET_COSTO_F3(state, costo) {
      state.costoF3 = costo
    },

    SET_PATROCINADOR_K10_DATA(state, data) {
      state.patrocinadorK10Data = data
    }
  },
  getters: {
    vistaActivaId: state => state.vistaActivaId,
    vistaDifusionActiva: state => state.vistaActivaId ? state.allVistas[state.vistaActivaId] : null,
    showSideNav: state => state.showSideNav,
    allVistas: state => state.allVistas,
    loadedAllVistas: state => state.loadedAllVistas,
    pubK10Disponibles: state => state.publicacionesDisponibles,

    //Cosas de saldo K10
    productoToF3: state => state.productoToF3,
    costoF3: state => state.costoF3,

    patrocinadorK10Data: state => state.patrocinadorK10Data,
  },
  actions: {
    updateVistaInAllVistas({ state, commit, dispatch }, vista) {
      commit('SET_VISTA_IN_ALL_VISTAS', {...(state.allVistas[vista.id] || {}), ...vista})
      if (vista.id === state.vistaActivaId) {
        dispatch('updateSavedVistaActiva')
      }
    },
    updateVistaActivaId({ commit, dispatch }, id) {
      commit('SET_VISTA_ACTIVA_ID', id)
      dispatch('updateSavedVistaActiva')
    },
    updateSavedVistaActiva({ state }) {
      if (state.vistaActivaId && state.allVistas[state.vistaActivaId]) {
        localStorage.setItem('vista-difusion-activa', JSON.stringify(state.allVistas[state.vistaActivaId]))
      } else {
        localStorage.removeItem('vista-difusion-activa')
      }
    },
    setAllVistas({ commit, dispatch }, obj) {
      commit('SET_ALL_VISTAS', obj)
      commit('SET_LOADED_ALL_VISTAS', true)
      dispatch('updateSavedVistaActiva')
    },
    async refreshState({ commit }) {
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)
    },
    async logoutActions({ commit, dispatch }) {
      // Lo mismo que en refresh state
      commit('SET_SHOW_SIDE_NAV', false)
      commit('SET_LOADED_ALL_VISTAS', false)
      commit('SET_PUBK10_DISPONIBLES', null)
      commit('SET_PATROCINADOR_K10_DATA', null)

      commit('SET_ALL_VISTAS',{})
      dispatch('updateVistaActivaId',null)
    }
  }
}